import { render, staticRenderFns } from "./NumberCases.vue?vue&type=template&id=5b135a94&scoped=true&"
import script from "./NumberCases.vue?vue&type=script&lang=js&"
export * from "./NumberCases.vue?vue&type=script&lang=js&"
import style0 from "./NumberCases.vue?vue&type=style&index=0&id=5b135a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b135a94",
  null
  
)

export default component.exports